import { render } from "./DocumentNameColumn.vue?vue&type=template&id=38b1ac61"
import script from "./DocumentNameColumn.vue?vue&type=script&lang=js"
export * from "./DocumentNameColumn.vue?vue&type=script&lang=js"

import "./DocumentNameColumn.vue?vue&type=style&index=0&id=38b1ac61&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__